// Trang con (UI_SPEC §4.2): trượt từ phải, phủ từ đáy hàng 1 topbar; bề mặt DUY NHẤT được cuộn.
// BACK ở góc trái-dưới thanh chân.
import type { JSX } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { t } from '@i18n/t';
import { closeSubpage, subpage, type SubpageId } from '@state/modules/ui';
import type { LogChannel } from '@state/modules/log';
import { TextButton } from '../kit/TextButton';
import { SelfPage } from '../pages/SelfPage';
import { TransmissionBody, TransmissionTabs } from '../pages/TransmissionPage';
import { EmptyPage } from '../pages/PlaceholderPages';
import { BagPage } from '../pages/BagPage';

const TITLE: Record<SubpageId, string> = {
  self: 'ui.profile',
  transmission: 'ui.transmission',
  bag: 'ui.rail.bag',
  tasks: 'ui.rail.tasks',
  mail: 'ui.rail.mail',
};

export function SubpageHost(): JSX.Element | null {
  const id = subpage.value;
  const [channel, setChannel] = useState<LogChannel>('system');
  const headRef = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    if (id) headRef.current?.focus();
  }, [id]);
  if (!id) return null;
  return (
    <section
      class="ht-subpage"
      role="dialog"
      aria-modal="true"
      aria-label={t(TITLE[id])}
      data-id={`subpage-${id}`}
    >
      <div class="ht-head">
        <h2 ref={headRef} tabIndex={-1}>
          {t(TITLE[id])}
        </h2>
      </div>
      {id === 'transmission' && (
        <div style={{ padding: '0 var(--gutter)' }}>
          <TransmissionTabs channel={channel} onSelect={setChannel} />
        </div>
      )}
      <div class="subpage-body" data-id="subpage-body">
        {id === 'self' && <SelfPage />}
        {id === 'transmission' && <TransmissionBody channel={channel} />}
        {id === 'bag' && <BagPage />}
        {(id === 'tasks' || id === 'mail') && <EmptyPage />}
      </div>
      <div class="subpage-foot">
        <TextButton variant="ghost" id="subpage-back" onClick={closeSubpage}>
          {t('ui.back')}
        </TextButton>
      </div>
    </section>
  );
}
